export default function HeroSection() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-background-200/60"></div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-xs font-semibold mb-6">
              <i className="ri-fire-line text-sm"></i>
              <span>今日热门对决实时更新</span>
            </div>

            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
              每日大赛官网
              <br className="hidden sm:block" />
              <span className="text-primary-500">娱乐PK与每日投票</span>直达现场
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-heading mb-6">
              围观话题对决 · 投出关键一票 · 吃瓜去水靠真热度
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-[600px] mx-auto lg:mx-0 mb-8">
              每日大赛官网是国内领先的娱乐PK投票入口，覆盖明星PK、话题对决、热门对决等泛娱乐领域。每天更新新鲜PK话题，千万吃瓜群众实时投票，数据去水透明可查。无论是最新八卦PK还是经典影视对决，这里都是你直达娱乐投票第一现场的必经之地。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">580万+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">日均活跃用户</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">1.2万+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">累计PK话题</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-500 font-heading">实时更新</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">每日新鲜话题</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => handleScroll(e, '#cards')}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-flashlight-line"></i>
                立即围观今日PK
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleScroll(e, '#ranking')}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-foreground-200 text-foreground-700 font-medium text-sm hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-bar-chart-grouped-line"></i>
                查看热门榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px] lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dramatic%20versus%20composition%20with%20two%20spotlights%20crossing%20on%20a%20stage%2C%20warm%20coral%20and%20golden%20lighting%2C%20theatrical%20atmosphere%2C%20minimalist%20cream%20background%20with%20subtle%20texture%2C%20editorial%20photography%20style%2C%20elegant%20and%20energetic&width=1000&height=800&seq=hero-main&orientation=portrait"
                alt="每日大赛娱乐PK投票现场主题视觉"
                className="w-full h-auto object-cover rounded-2xl"
                width="1000"
                height="800"
              />
              <div className="absolute bottom-4 left-4 right-4 flex gap-2">
                <div className="flex-1 bg-background-50/90 backdrop-blur-sm rounded-xl px-4 py-3 text-center">
                  <div className="text-xs text-foreground-500">今日最热</div>
                  <div className="text-sm font-bold text-primary-500 font-heading">古装男神PK</div>
                </div>
                <div className="flex-1 bg-background-50/90 backdrop-blur-sm rounded-xl px-4 py-3 text-center">
                  <div className="text-xs text-foreground-500">实时票数</div>
                  <div className="text-sm font-bold text-accent-500 font-heading">328.6万</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}